module.exports = __webpack_public_path__ + "static/img/装饰5.930c5d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装饰5.svg
// module id = rygy
// module chunks = 2